var _path, _path2, _path3, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCertificateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9012 60.6054H54.5939C55.1933 60.6054 55.6792 60.101 55.6792 59.4786V5.73216C55.6792 5.10985 55.1933 4.6054 54.5939 4.6054H14.9013C14.3019 4.6054 13.816 5.10985 13.816 5.73216V59.4786C13.8159 60.101 14.3019 60.6054 14.9012 60.6054Z",
    fill: "url(#paint0_linear_286_4625)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6977 56.9213C51.2456 56.9213 52.5004 55.6665 52.5004 54.1187V10.9082C52.5004 9.36032 51.2456 8.10554 49.6977 8.10554H19.3819C17.8341 8.10554 16.5793 9.36032 16.5793 10.9082L16.5793 54.1187C16.5793 55.6665 17.8341 56.9213 19.3819 56.9213H49.6977Z",
    fill: "url(#paint1_linear_286_4625)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5901 50.9555C32.1557 50.9593 30.7214 50.9626 29.287 50.9649C28.8263 50.9656 28.3654 50.9662 27.9047 50.9665C27.5521 50.9667 27.1716 51.0267 26.8737 50.8075C26.5403 50.5622 26.4256 50.2158 26.3493 49.8342C26.184 49.0078 24.9464 49.1131 24.7195 49.8342C24.6192 50.1536 24.1121 51.068 23.6692 50.9932C23.4345 50.9536 23.3319 50.6049 23.2452 50.4243C23.0763 50.0728 22.9532 49.7002 22.8479 49.3269C22.403 47.7495 22.3143 46.1026 22.0359 44.4956C21.8746 43.5636 20.3998 43.8271 20.376 44.712C20.3003 47.5305 19.8219 50.3105 18.7801 52.9523C18.3935 53.9327 20.0267 54.3566 20.4098 53.3851C20.8115 52.3665 21.1304 51.3234 21.3778 50.2649C21.5105 50.6506 21.6688 51.0289 21.8621 51.3969C22.3556 52.3363 23.3621 52.8921 24.4391 52.4743C24.8234 52.3252 25.1741 52.0645 25.4726 51.7472C25.5147 51.794 25.5572 51.8403 25.6016 51.8834C26.4212 52.6804 27.4993 52.5951 28.5714 52.5938C30.2443 52.5917 31.9172 52.5879 33.5902 52.5834C34.6775 52.5805 34.6795 50.9526 33.5901 50.9555Z",
    fill: "#232D38"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_286_4625)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.658 67.2373L46.0527 66.0737L41.4474 67.2373V57.1057H50.658V67.2373Z",
    fill: "url(#paint2_linear_286_4625)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4756 62.5774C45.3311 62.5774 44.5816 60.6328 43.5864 60.2201C42.5547 59.7923 40.6533 60.6213 39.8758 59.8437C39.0983 59.0662 39.9273 57.1648 39.4994 56.1332C39.0867 55.138 37.1422 54.3886 37.1422 53.244C37.1422 52.0996 39.0867 51.3502 39.4994 50.3548C39.9273 49.3232 39.0983 47.4218 39.8758 46.6444C40.6533 45.867 42.5547 46.6959 43.5863 46.2681C44.5815 45.8554 45.3309 43.9108 46.4754 43.9108C47.62 43.9108 48.3694 45.8554 49.3646 46.2681C50.3963 46.6959 52.2977 45.867 53.0752 46.6445C53.8527 47.422 53.0238 49.3234 53.4516 50.355C53.8643 51.3502 55.8089 52.0996 55.8089 53.2442C55.8089 54.3886 53.8643 55.138 53.4516 56.1334C53.0238 57.165 53.8527 59.0664 53.0752 59.8438C52.2977 60.6213 50.3963 59.7923 49.3648 60.2201C48.3696 60.6328 47.6201 62.5774 46.4756 62.5774Z",
    fill: "url(#paint3_linear_286_4625)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.4757,
    cy: 53.2443,
    r: 4.66667,
    fill: "url(#paint4_linear_286_4625)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_286_4625",
    x: 33.4053,
    y: 43.9108,
    width: 26.1404,
    height: 30.8002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.73684
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86842
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_286_4625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_286_4625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_286_4625",
    x1: 55.6792,
    y1: 60.6054,
    x2: 13.816,
    y2: 60.6054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31FF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_286_4625",
    x1: 16.5793,
    y1: 56.9213,
    x2: 52.5004,
    y2: 56.9213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6FFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253059,
    stopColor: "#F6FFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_286_4625",
    x1: 41.4474,
    y1: 57.1057,
    x2: 41.4474,
    y2: 67.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#14FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_286_4625",
    x1: 37.1422,
    y1: 43.9108,
    x2: 37.1422,
    y2: 62.5774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C336"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_286_4625",
    x1: 41.809,
    y1: 48.5776,
    x2: 41.809,
    y2: 57.9109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#14FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFF00"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateIcon);
export default __webpack_public_path__ + "static/media/certificateIcon.561cc7db744115aa7216846b3a297648.svg";
export { ForwardRef as ReactComponent };